module.exports = __webpack_public_path__ + "img/1-5.b9143413.png";